<template>
  <div
    class="d-flex flex-sm-row flex-lg-column justify-sm-start justify-lg-center fill-height"
  >
    <span class="text--secondary mb-3">{{ label }}</span>
    <span class="ml-sm-2 ml-lg-0">{{ value }}</span>
  </div>
</template>

<script>
export default {
  name: "ExpansionPanelHeaderDefault",
  props: ["label", "value"]
};
</script>

<style lang="scss" scoped></style>
